// React&NextJS
import React from 'react'
// 3rd party libraries
import { motion } from 'framer-motion'
// Styles
import s from './Table.module.scss'
import classnames from 'classnames'
// Components
import { ButtonMap } from '../buttonMap/ButtonMap'
import { Button } from '../../core/button/Button'

const c = classnames.bind(s)

type LinkButtonType = {
    label: string
    to: string
    after: string
    [key: string]: unknown
}

type FuncButtonType = {
    label: string
    func: Function
    [key: string]: unknown
}

type Row = {
    id?: string
    col1: JSX.Element
    col2: JSX.Element
    col3: JSX.Element
    buttons?: Array<LinkButtonType | FuncButtonType>
}

type Props = {
    className?: string
    content: Array<Row>
    headers: Row
    type?: 0 | 1 | 2
    [key: string]: unknown
    fadeIn?: Boolean
}

export const Table = ({ type = 0, content, headers, fadeIn = true }: Props) => {
    let c_1 = 'con_1'
    let c_2 = 'con_2'
    let c_3 = 'con_3'

    if (type === 1) {
        c_1 = 'con_1'
        c_2 = 'con_2'
        c_3 = 'con_3'
    } else if (type === 2) {
        c_1 = 'obi2_1'
        c_2 = 'obi2_2'
        c_3 = 'obi2_3'
    } else {
        c_1 = 'obi_1'
        c_2 = 'obi_2'
        c_3 = 'obi_3'
    }

    const container = {
        hidden: {
            opacity: 0,
        },
        show: {
            opacity: 1,
            transition: {
                staggerChildren: 0.2,
            },
        },
    }

    const item = {
        hidden: {
            opacity: 0,
            transform: 'translateY(200px)',
            transition: {
                duration: 0.6,
                type: 'tween',
                staggerChildren: 1,
            },
        },
        show: {
            transform: 'translateY(0px)',
            opacity: 1,
            transition: {
                duration: 0.6,
                type: 'tween',
                staggerChildren: 1,
            },
        },
    }

    return (
        <motion.div
            className={s.container}
            variants={container}
            initial={fadeIn ? 'hidden' : 'show'}
            animate="show"
        >
            <ul className={c(s.row, s.headers)}>
                <li className={c(s.column, s[c_1])}>{headers.col1}</li>
                <li className={c(s.column, s[c_2])}>{headers.col2}</li>
                <li className={c(s.column, s[c_3])}>{headers.col3}</li>
            </ul>
            {content.map((row, i) => {
                if (row) {
                    return (
                        <motion.ul key={i} className={s.row} variants={item}>
                            <li className={c(s[c_1], s.column)}>{row.col1}</li>

                            <li className={c(s.column, s[c_2])}>
                                <p className={c(s.phone_header)}>
                                    {headers.col2.props.children ===
                                        'Sett in af' ||
                                    headers.col2.props.children === 'Frá'
                                        ? headers.col2.props.children.substring(
                                              0,
                                              3
                                          )
                                        : headers.col2.props.children}
                                    :&nbsp;
                                </p>
                                {row.col2}
                            </li>

                            <li className={c(s.column, s[c_3])}>
                                <p className={c(s.phone_header)}>
                                    {headers.col3.props.children ===
                                        'Sett in af' ||
                                    headers.col3.props.children === 'Frá'
                                        ? headers.col3.props.children.substring(
                                              0,
                                              3
                                          )
                                        : headers.col3.props.children}
                                    :&nbsp;
                                </p>

                                {row.col3}
                            </li>
                            <ButtonMap className={s.buttonMap}>
                                {row.buttons.map((button, b) => {
                                    let funcBtn: FuncButtonType = null
                                    let linkBtn: LinkButtonType = null
                                    if (button['func']) {
                                        funcBtn = button as FuncButtonType
                                    } else {
                                        linkBtn = button as LinkButtonType
                                    }
                                    return (
                                        <Button
                                            key={b}
                                            variant="text"
                                            onClick={() => {
                                                if (funcBtn) {
                                                    funcBtn.func()
                                                }
                                            }}
                                            to={
                                                linkBtn
                                                    ? button['to'] +
                                                      row.id +
                                                      button['after']
                                                    : null
                                            }
                                        >
                                            {button.label}
                                        </Button>
                                    )
                                })}
                            </ButtonMap>
                            <div className={s.line} />
                        </motion.ul>
                    )
                }
            })}
        </motion.div>
    )
}
